<!--
 * @Description: 批改作业管理 列表页
 * @Author: PF
 * @Date: 2022-09-23 11:53:25
 * @LastEditors: PF
 * @LastEditTime: 2026-09-07 16:03:47
-->
<template>
  <div class="list-page">
    <el-dialog class="wp90 hp90" v-model="openList" :close-on-click-modal="false" :show-close="false" destroy-on-close style="min-width: 1030;">
      <template #header>
        <div class="header-left">
          <el-icon class="header-icon">
            <Suitcase />
          </el-icon>
          <span class="header-title">批改</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="openList=false;homeCloseWindow('openReturn', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
    <el-container>
      <el-header>
        <!-- 搜索区域 BEGIN -->
        <div class="button-box">
          <el-form class="search-box mb0" :model="dataGrid.parms">
            <el-form-item>
              <el-select placeholder="学期" v-model="dataGrid.parms.xqid" clearable filterable :teleported="false" @change="bindTable()" >
                <el-option v-for="item in xqData" :key="item.id" :label="item.xqmc" :value="item.id"/>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-select placeholder="班级" v-model="dataGrid.parms.bjid" filterable clearable :teleported="false" @change="bindTable()">
                <el-option v-for="item in bjData" :key="item.id" :label="item.xzbmc" :value="item.id"/>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-select placeholder="课程" v-model="dataGrid.parms.kcid" filterable clearable :teleported="false" @change="initJiaoXueDanYuan();bindTable()">
                <el-option v-for="item in kcData" :key="item.id" :label="item.kcmc" :value="item.id"/>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-select placeholder="教学单元" v-model="dataGrid.parms.jxdyid" filterable clearable :teleported="false" @change="initJiaoXueNeiRong();bindTable()">
                <el-option v-for="item in jxdyData" :key="item.id" :label="item.jxdybt" :value="item.id" />
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-select placeholder="教学内容" v-model="dataGrid.parms.jxnrid" filterable clearable :teleported="false" @change="bindTable()">
                <el-option v-for="item in jxnrData" :key="item.id" :label="item.jxnrbt" :value="item.id" />
              </el-select>
            </el-form-item>
            <el-form-item v-if="activeName===2">
              <el-select placeholder="作业类型" v-model="dataGrid.parms.zylx" filterable clearable :teleported="false" @change="bindTable()">
                <el-option v-for="item in zylxData.list" :key="item.value" :label="item.name" :value="item.value"/>
              </el-select>
            </el-form-item>
          </el-form>
          <el-tabs v-model="activeName" @tab-change="bindTable()">
            <el-tab-pane label="未批改" :name="1"></el-tab-pane>
            <el-tab-pane label="已批改" :name="2"></el-tab-pane>
          </el-tabs>
        </div>
        <!-- 搜索区域 END -->
        <!-- 按钮区域 BEGIN -->
        <div class="button-box" v-if="activeName===2">
          <el-button type="primary" @click="openAdd=true"><span class="iconfont icon-chuangjian"></span>添加线下作业</el-button>
        </div>
        <!-- 按钮区域 END -->
      </el-header>
      <el-main>
        <el-table :data="dataGrid.data" :default-sort="dataGrid.orderBy" v-loading="dataGrid.loading" @sort-change="dataGrid.sortChange" height="100%" border stripe>
          <!-- 冻结列-Left BEGIN -->
          <el-table-column label="序号" type="index" width="60" fixed align="center" />
          <el-table-column label="课程" prop="kcmc" fixed align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']"/>
          <el-table-column label="班级" prop="bjmc" fixed align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']"/>
          <el-table-column label="作业名称" prop="zymc" fixed align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']"/>
          <el-table-column label="教学单元" prop="jxdybt" fixed align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']"/>
          <el-table-column label="教学内容" prop="jxnrbt" fixed align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']"/>
          <!-- 冻结列-Left END -->
          <el-table-column label="发布时间" prop="bzsj" width="140" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']"/>
          <el-table-column label="截止时间" prop="jzsj" width="140" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']"/>
          <el-table-column label="作业类型" v-if="activeName===2" width="110" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']">
            <template #default="scope">
              <span v-for="(item, index) in zylxData.list" :key="index">
                <span v-if="item.value === scope.row.zylx">{{item.name}}</span>
              </span>
            </template>
          </el-table-column>
          <el-table-column label="完成情况" prop="ytjrs" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']">
            <template #default="scope">
              <span>{{ scope.row.ytjrs || 0 }}<span v-if="scope.row.ytjrs!==null && scope.row.wtjrs!==null">/</span>{{ scope.row.ytjrs + scope.row.wtjrs}}</span>
            </template>
          </el-table-column>
          <el-table-column label="批改情况" prop="ypgrs" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']">
            <template #default="scope">
              <span>{{ scope.row.ypgrs || 0 }}</span>
            </template>
          </el-table-column>
          <!-- 冻结列-Right BEGIN -->
          <el-table-column label="操作" width="120" fixed="right" align="center">
            <template #default="scope">
              <el-button v-if="activeName===1" link type="success" @click="openPiGaiList=true; row=scope.row">批改</el-button>
              <el-button v-if="activeName===2" link type="success" @click="openPiGaiList=true; row=scope.row">详情</el-button>
            </template>
          </el-table-column>
          <!-- 冻结列-Right END -->
        </el-table>
      </el-main>
    </el-container>
      <template #footer>
        <div v-if="activeName===1" class="dialog-footer">
          <pagination :pagination="dataGrid.pagination" @ReturnData="bindTable" />
        </div>
      </template>
    </el-dialog>
  </div>
  <pigailist v-if="openPiGaiList" v-model:openPiGaiList="openPiGaiList" :row="row" @ReturnData="bindTable" />
  <xianxiaadd v-if="openAdd" v-model:openAdd="openAdd" :row="row" @ReturnData="bindTable" />
</template>

<script setup>
import { ref, watch, defineProps, defineEmits } from 'vue'
import { loadList, loadSelect, homeCloseWindow, actionPost } from '@/api/common.js'
import { warningPrompt } from '@/utils/promptInfo.js'
import pagination from '@/components/pagination.vue'
import pigailist from './pigailist.vue'
import xianxiaadd from './xianxiaadd.vue'

const props = defineProps({ open: { type: String, required: true }, row: { type: Object, required: false } })
const emits = defineEmits(['openReturn', 'ReturnData'])

const activeName = ref(1)
// 加载 作业类型 下拉框
const zylxData = ref({ list: [] })
loadSelect({ url: '/api/v2/ziyuanku/zuoye/zuoyeleixing', data: zylxData })
// 加载 学期 下拉框
const xqData = ref()
const xqChange = () => {
  loadSelect({
    url: '/api/v2/pdp/xueqi/list',
    data: xqData,
    order: 'sx',
    sort: 'asc',
    loadSuccess: function (res) {
      if (res.data.length) {
        res.data.forEach((item) => {
          if (item.sfdqxq === true) {
            dataGrid.value.parms.xqid = item.id
            bindTable()
          }
        })
      }
    }
  })
}
// 加载 班级 下拉框
const bjData = ref([])
const bjChange = () => {
  loadSelect({
    url: '/api/v2/pdp/banji/listjiaoshi',
    data: bjData,
    order: 'xq',
    sort: 'asc'
  })
}
// 加载 课程 下拉框
const kcData = ref([])
const kcChange = () => {
  loadSelect({
    url: '/api/v2/jiaowu/kecheng/jiaoshi',
    data: kcData
  })
}

// 加载 教学单元 下拉框
const initJiaoXueDanYuan = (val) => {
  kcData.value.forEach((element) => {
    if (val === element.id) {
      ruleForm.value.kcmc = element.kcmc
      loadSelect({
        url: '/api/v2/ziyuanku/kechengjiaoxuedanyuan/list',
        data: jxdyData,
        parms: { kcid: ruleForm.value.kcid, order: 'sx', sort: 'asc' }
      })
    }
  })
}
// 加载 教学内容 下拉框
const initJiaoXueNeiRong = (val) => {
  jxdyData.value.forEach((element) => {
    if (val === element.id) {
      loadSelect({
        url: '/api/v2/ziyuanku/kechengjiaoxueneirong/list',
        data: jxnrData,
        parms: { jxdyid: ruleForm.value.jxdyid, order: 'sx', sort: 'asc' }
      })
    }
  })
}
const dataGrid = ref({
  parms: {},
  data: [],
  pagination: {},
  loading: false,
  orderBy: { prop: 'bzsj', order: 'descending' }, // ['ascending', 'descending']
  sortChange: function (column) {
    dataGrid.value.orderBy.prop = column.prop
    dataGrid.value.orderBy.order = column.order
    bindTable()
  }
})
const bindTable = async (pageNo, pageSize) => {
  switch (activeName.value) {
    case 1:
      loadList({
        url: '/api/v2/ziyuanku/xueshengzuoye/dangqianjiaoshibuzhiweipigaizouye',
        pageNo: pageNo || 1,
        pageSize: pageSize || 100,
        pagerCount: 5,
        dataGrid: dataGrid.value
      })
      break
    case 2:
      dataGrid.value.data = []
      dataGrid.value.loading = true
      dataGrid.value.parms.order = 'bzsj'
      dataGrid.value.parms.sort = 'desc'
      actionPost({ url: '/api/v2/ziyuanku/xueshengzuoye/dangqianjiaoshibuzhiyipigaizouye', data: dataGrid.value.parms }).then((res) => {
        dataGrid.value.loading = false // 结束加载
        if (res.code === 200) {
          dataGrid.value.data = res.data || [] // 返回列表
        } else {
          warningPrompt(res.message)
        }
      })
      break
  }
}

// 弹窗
const row = ref()
const openAdd = ref(false)
const openPiGaiList = ref(false)
const openList = ref(false)
watch(
  () => props.open,
  () => {
    if (props.open === 'pigaizuoye') {
      openList.value = true
      xqChange()
      bjChange()
      kcChange()
    } else {
      openList.value = false
    }
  },
  { deep: true, immediate: true }
)

</script>

<style lang="less" scoped>
  .button-box {
    justify-content: space-between;
  }
  .el-tabs__content {
    display: none;
  }
</style>
